// extracted by mini-css-extract-plugin
export default {"main":"Apploader_main__tuQ2i"};